<template>
  <footer class="app-footer">
    <span>网易公司版权所有 &copy; 1997-2018</span>
    <span class="ml-auto">Powered by <a href="http://coreui.io">CoreUI</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?07120be8